import { Flex } from 'foundations-components/components/Flex';
import { breakpointValues, trellisBreakpoint } from 'pricing-pages-lib/constants/Breakpoints';
import { useEffect } from 'react';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import styled from 'foundations-theming/utils';
import { fetchPerProductPricingApiCompleted, fetchPerProductPricingApiFailed, fetchPerProductPricingApiStarted, planBuilderInitializationComplete } from '../../actions/PlanBuilderActions';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { usePlanBuilderPurchaseOptions } from '../../hooks/usePurchaseOptions';
import { useAppDispatch, useAppSelector } from '../../reducers';
import { planBuilderCommonTermForProductConfigurationsSelector } from '../../selectors/PlanBuilderSelectors';
import { suiteProductConfigurationsSelector } from '../../selectors/ProductConfigsSelectors';
import { useQueryParamProductConfigsOrDefault } from '../../utils/planBuilderUtils/PlanBuilderQueryParamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "PlanBuilderContent__Wrapper",
  componentId: "ijlujj-0"
})(({
  theme
}) => {
  return {
    width: '100%',
    marginBlock: theme.space[0],
    marginInline: 'auto',
    padding: theme.space[0],
    [trellisBreakpoint.phone]: {
      width: 'inherit'
    }
  };
});
const PlanBuilderContent = ({
  children
}) => {
  const dispatch = useAppDispatch();
  const isAppReady = useGlobalLoading();

  // Default to Starter CP
  const defaultProductConfigurations = useAppSelector(state => {
    if (!isAppReady) {
      return [];
    }
    return suiteProductConfigurationsSelector(state, {
      productLevel: STARTER
    });
  });

  // Get the product configurations from the query params if present otherwise use the default
  const initialProductConfigurationsUsingQueryParams = useQueryParamProductConfigsOrDefault({
    defaultConfigurations: defaultProductConfigurations
  });
  const commonTermForProductConfigurations = useAppSelector(planBuilderCommonTermForProductConfigurationsSelector);
  useEffect(() => {
    dispatch(planBuilderInitializationComplete({
      productConfigurations: initialProductConfigurationsUsingQueryParams
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // fetch per-product pricing, cache, and dispatch fetch actions
  const {
    loading: popPricingLoading
  } = usePlanBuilderPurchaseOptions({
    term: commonTermForProductConfigurations,
    onCompleted: ({
      pricingData
    }) => {
      dispatch(fetchPerProductPricingApiCompleted(pricingData));
    },
    onError: () => {
      dispatch(fetchPerProductPricingApiFailed());
    }
  });
  useEffect(() => {
    // Triggering based on `loading` since DFC doesn't have an onLoading callback
    // the onCompleted and onError callbacks will clear this loading state
    if (popPricingLoading) {
      dispatch(fetchPerProductPricingApiStarted());
    }
  }, [popPricingLoading, dispatch]);
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: window.innerWidth < breakpointValues.cs ? 'column' : 'row',
      alignItems: window.innerWidth < breakpointValues.cs ? 'center' : undefined,
      children: children
    })
  });
};
export default PlanBuilderContent;